import React from 'react' // eslint-disable-line

import styled from 'styled-components'
const tabletWidth = 1200
const mobileWidth = 980
export const CaseStudy = styled.div`
  display: flex;
  flex-direction: row;
  padding: 80px 52px;
  align-items: center;
  [data-type='text-section'] {
    margin-left: 115px;
    width: 100%;
    max-width: none;
    [data-type='title'] {
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 2.24px;
      text-transform: uppercase;
      margin: 0;
    }
    [data-type='site'] {
      color: #333;
      font-size: 44px;
      font-style: normal;
      font-weight: 400;
      line-height: 50px;
      margin-top: 5px;
      margin-bottom: 0;
    }
    [data-type='award'] {
      color: #333;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px;
      letter-spacing: 1.26px;
      margin-top: 5px;
      margin-bottom: 0;
    }
    [data-type='text'] {
      color: #333;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      margin: 40px 0;
      text-align: left;
    }
    [data-type='case-study-link'] {
      max-width: 305px;
      width: 100%;
      height: 60px;
      border: 1px solid #262626;
      color: #262626;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 0.9px;
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: ${tabletWidth}px) {
    padding: 80px 28px;
    [data-type='image'] {
      width: 568px;
      height: 379px;
    }
    [data-type='text-section'] {
      margin-left: 51px;
    }
  }
  @media (max-width: ${mobileWidth}px) {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    [data-type='image'] {
      height: 250px;
      width: 100%;
      max-width: none;
    }
    [data-type='text-section'] {
      margin: 0;
      padding: 30px 16px 60px 16px;
      width: 100%;
      [data-type='title'] {
        color: #333;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 2.08px;
      }
      [data-type='site'] {
        color: #333;
        font-size: 30px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px;
      }
      [data-type='award'] {
        color: #333;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.91px;
      }
      [data-type='text'] {
        margin-top: 16px;
        margin-bottom: 40px;
        color: #333;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      [data-type='case-study-link'] {
        max-width: none;
        width: 100%;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 1.92px;
      }
    }
  }
`